import React from 'react';
import { Icon } from '../Icon';
import { IIcon } from '@interfaces';

export function PhoneIcon(props: IIcon) {
    return (
        <Icon
            width={props.width}
            height={props.height}
            viewBox={props.viewBox}
            style={props.style}
            className={props.className}
        >
            <path
                id="phone"
                d="M512.83,404.84c-.81-19.6-12.83-38.48-36.76-57.7-32.18-25.87-57-36.36-78-33-19,3-32.62,16.87-47.07,31.52l-5.16,5.21c-5.59,5.59-19.77,1.66-38.91-10.78-18.49-12-41.66-31.91-68.87-59.12-84.54-84.54-73-104.6-69.89-107.76l5.16-5.11C188,153.63,201.85,140,204.89,121c3.37-21.06-7.11-45.86-33-78.06C152.65,19,133.79,7,114.19,6.16c-28.55-1-49.66,21.22-68.26,40.77l-.38.4c-2.95,3.1-5.73,6-8.5,8.81-20.72,20.7-20.84,65.56-.31,120C59.13,235.47,103.32,300,161.16,357.85s122.37,102,181.69,124.38c26.66,10.06,51.7,15.38,72.42,15.38,20.92,0,37.37-5.4,47.57-15.62,2.52-2.51,5.16-5,8-7.68l1.24-1.18C491.7,454.45,514,433.28,512.83,404.84ZM60.31,61.07l.25-.27c15.38-16.18,32.8-34.52,51.59-34.52h1.2c13.25.57,27.66,10.4,42.85,29.24C177.72,82.3,186.54,101,184.78,116.1c-1.63,14-12.22,24.43-25.63,37.62l-5.25,5.18c-22.63,22.68-.42,66,69.89,136.28,28.16,28.17,52.43,49,72.14,61.78,29.07,18.9,50.66,21.63,64.15,8.11l5.27-5.32c13.19-13.37,23.6-23.94,37.6-25.54,15.12-1.74,33.77,7.08,60.52,28.59,18.85,15.15,28.69,29.56,29.24,42.83.8,19.26-18,37.1-34.54,52.84-3.34,3.16-6.58,6.24-9.57,9.22-14.52,14.53-53.24,12.83-98.62-4.32C293.31,442,231.32,399.49,175.43,343.61S77,225.74,55.61,169c-17.13-45.42-18.81-84.14-4.3-98.64C54.25,67.44,57.19,64.35,60.31,61.07Z"
            />
        </Icon>
    );
}
